import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const saveNewMajorOperation = async (
  majorName: string,
  setLoading: (isLoading: boolean) => void,
) => {
  try {
    if (!majorName || majorName.length < 3) {
      toast.warn(`יש להזין שם מגמה תקין, מעל שלושה תווים`);
      console.warn(`Major name must not be empty`);
      return;
    }
    setLoading(true);
    const existingMajor = globalSettingsStores.majors.find(
      (item) => item.majorName === majorName,
    );
    if (existingMajor) {
      toast.warn('קיים שם מגמה');
      return;
    }
    const newMajorRes = await appApi.addMajor(majorName);

    globalSettingsStores.majors.push(newMajorRes.data.body);

    setLoading(false);
    toast.success(`הוספת ${majorName} התבצעה בהצלחה`);
    return;
  } catch (e) {
    setLoading(false);
    toast.error('הוספת מגמה נכשלה ');
    console.error(
      `SaveNewMajorOperation is failed with majorName: ${majorName} and the error: ${e}`,
    );
  }
};
